
import {Vue, Component} from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/zh-cn';
import {aiConfigObj, frequencyAiTypes} from '@/js/aiConfig/aiconfig-list.helper';

import {aiconfigApi} from '@/api';
@Component
export default class school_AIfrenquency_edit extends Vue {
    //===================================data区域begin
    aiConfigObj = aiConfigObj;
    frequencyAiTypes: string[] = frequencyAiTypes;
    hasTotalConfig: boolean = false;
    //数据表单的校验
    formRules: any = {
        ...frequencyAiTypes.reduce((result, aiType) => {
            result[aiType] = this.getRule(aiType, this.isTimeType(aiType) ? 'time' : 'number');
            return result;
        }, {} as any)
    };
    form: any = []; //数据表单
    role: any = this.$router.currentRoute.query.role; //修改的角色
    schoolAdress: string = '';
    orgName: string = '';
    frequencyData: any = [];
    overview: any = '';
    configId: any = this.$router.currentRoute.query.id; //当前配置的id
    //===================================data区域end
    //===================================computed区域begin
    get isResearchOrTeacher() {
        return this.role === '教研员' || this.role === '教师';
    }

    //===================================computed区域end
    created() {
        this.hasTotalConfig = JSON.parse(window.localStorage.getItem('schoolInfo') as string).totalQuotaConfig === true;
        // 获取学校及行政区数据
        this.schoolAdress = JSON.stringify(this.$route.query.schoolAdress).replace(/"/g, '');
        this.orgName = JSON.stringify(this.$route.query.orgName).replace(/"/g, '');
        let frequencyList = window.localStorage.getItem('frequencyData');
        frequencyList = JSON.parse(JSON.stringify(frequencyList));
        this.overview = JSON.parse(frequencyList as any).overview;
        if (frequencyList === null) return;
        const roleData: {
            [x: string]: string;
        } = {
            教研员: 'research',
            教师: 'teacher',
            学生: 'student'
        };
        const roleKey = roleData[this.role];
        if (roleKey) {
            this.form = JSON.parse(frequencyList).detail[roleKey];
            this.form['asr-rt'].max = this.form['asr-rt'].max / 60000;
            if (this.form['asr-rt'].threshold != '' && this.form['asr-rt'].threshold > 0) {
                this.form['asr-rt'].threshold = this.form['asr-rt'].threshold / 60000;
            }
            if (this.form['asr-rt'].total && this.form['asr-rt'].total > 0) {
                this.form['asr-rt'].total = this.form['asr-rt'].total / 60000;
            }
            this.form.copyTo = [];
        }
        // console.log(this);
    }
    beforeDestroy() {
        // window.localStorage.removeItem('frequencyData');
    }
    //===================================methods区域begin
    isTimeType(aiType: string) {
        return aiType === 'asr-rt';
    }
    getRule(aiType: string, inputType: 'number' | 'time') {
        const isTime = inputType === 'time';
        const rules: any = {
            max: [
                {
                    required: true,
                    message: '请输入整数值',
                    trigger: 'blur'
                },
                {validator: this.checkNumber, trigger: 'blur'},
                {
                    validator: (...args: [any, any, any]) =>
                        isTime ? this.checkTimeMax(aiType, ...args) : this.checkNumberMax(aiType, ...args),
                    trigger: 'blur'
                }
            ],

            threshold: [
                {
                    required: false,
                    message: '请输入整数值',
                    trigger: 'blur'
                },
                {validator: (...args: [any, any, any]) => this.checkSize(aiType, ...args), trigger: 'blur'},
                {validator: this.checkNumber, trigger: 'blur'}
            ],
            from: [
                {
                    required: true,
                    message: '请填写使用期限',
                    trigger: 'change'
                }
            ],
            to: [
                {
                    required: true,
                    message: '请填写使用期限',
                    trigger: 'change'
                },
                {validator: (...args: [any, any, any]) => this.checkDate(aiType, ...args), trigger: 'change'}
            ]
        };
        if (this.hasTotalConfig) {
            rules.total = [
                {
                    required: false,
                    message: '请输入整数值',
                    trigger: 'blur'
                },
                {validator: (...args: [any, any, any]) => this.checkTotal(aiType, ...args), trigger: 'blur'},
                {validator: this.checkNumber, trigger: 'blur'}
            ];
        }
        return rules;
    }
    //校验限定额度是否大于学校额度
    checkNumberMax(type: string, rule: any, value: any, callback: any) {
        if (value) {
            if (this.form[type].max != '' && +this.overview[type].max < +this.form[type].max) {
                callback(new Error('学校额度' + this.overview[type].max + '次，角色频次额度不可高于学校额度。'));
            } else {
                callback();
            }
        }
        callback();
    }
    checkTimeMax(type: string, rule: any, value: any, callback: any) {
        if (value) {
            if (this.form[type].max != '' && +this.overview[type].max < +this.form[type].max * 60000) {
                callback(new Error('学校额度' + this.overview[type].max / 60000 + '分钟，角色频次额度不可高于学校额度。'));
            } else {
                callback();
            }
        }
        callback();
    }
    //校验结束日期是否合理
    checkDate(type: string, rule: any, value: any, callback: any) {
        if (this.form.tts.from) {
            if (!moment(this.form[type].from).isBefore(this.form[type].to)) {
                callback(new Error('不能早于开始时间!'));
            } else {
                callback();
            }
        }
    }
    //校验整数值
    checkNumber(rule: any, value: any, callback: any) {
        if (value) {
            if (!/^[1-9]\d*$/g.test(value)) {
                callback(new Error('请输入整数值!'));
            } else {
                callback();
            }
        }
        callback();
    }
    //校验预警值是否比限定额度小
    checkSize(type: string, rule: any, value: any, callback: any) {
        if (value) {
            if (this.form[type].max != '' && +this.form[type].max <= +this.form[type].threshold) {
                callback(new Error('必须小于限定额度!'));
            } else {
                callback();
            }
        }
        callback();
    }
    // 校验总额度是否超出最大值
    checkTotal(type: string, rule: any, value: any, callback: any) {
        const max = this.overview[type].max;
        if (value && max && max <= this.form[type].total) {
            return callback(new Error('必须小于学校总额度!'));
        }
        callback();
    }
    disabledFromDateFn(current: any, disabledToDay: string) {
        return current && current > moment(disabledToDay);
    }
    disabledToDateFn(current: any, disabledFromDay: string) {
        return current && current < moment(disabledFromDay);
    }

    copy(e: any, flag: any) {
        // console.log(e, flag);
        if (e.target.checked) {
            if (flag == 'research') {
                this.form.copyTo.push('research');
            } else if (flag == 'teacher') {
                this.form.copyTo.push('teacher');
            } else if (flag == 'student') {
                this.form.copyTo.push('student');
            }
        } else {
            for (let i = 0; i < this.form.copyTo.length; i++) {
                if (flag == this.form.copyTo[i]) {
                    this.form.copyTo.splice(i, 1);
                }
            }
        }
    }
    onSave() {
        let me = this;
        let saveForm = JSON.parse(JSON.stringify(me.form));
        if (me.role == '教研员') {
            saveForm.role = 'research';
            // 老师和教研配置要求一样
            saveForm.copyTo.push('teacher');
        } else if (me.role == '教师') {
            saveForm.role = 'teacher';
            // 老师和教研置要求一样
            saveForm.copyTo.push('research');
        } else if (me.role == '学生') {
            saveForm.role = 'student';
        }
        if (saveForm['asr-rt'].threshold != '') {
            saveForm['asr-rt'].threshold *= 60000;
        }
        saveForm['asr-rt'].max *= 60000;
        if (this.hasTotalConfig && saveForm['asr-rt'].total != '' && saveForm['asr-rt'].total > 0) {
            saveForm['asr-rt'].total *= 60000;
        }

        // 用于判断表单校验是否通过
        let fooBoolean: boolean = true;
        for (let i = 1; i < 10; i++) {
            let rules: string = `formRules${i}`;
            const validate = (me.$refs[rules] as any).validate || (me.$refs[rules] as any)[0]?.validate;
            validate &&
                validate((valid: any) => {
                    if (!!valid === false) {
                        fooBoolean = false;
                        console.log('error...........');
                        return;
                    }
                });
        }
        if (fooBoolean) {
            let data: any = saveForm;
            aiconfigApi.editAIFrequency({
                context: me,
                data: data,
                urlParamsObj: {
                    id: me.configId
                },
                success(data: any, parameters: any) {
                    me.$message.success('保存成功，五分钟内生效！');
                    window.localStorage.setItem('isFrequency', 'true');
                    me.$router.go(-1);
                },
                error(error: any, message: string, parameters: any) {
                    me.$message.error(error.response.data.emsg);
                    // me.$router.go(-1);
                }
            });
        }
    }
    onCancel() {
        window.localStorage.setItem('isFrequency', 'true');
        this.$router.go(-1);
    }
    //===================================methods区域end
}
